import type { ReactNode, Ref } from 'react';

/**
 * The card a section sits in (crossmarc/steward-app#1886): the eyebrow "Section N of M", then
 * the h1, then the intro. The eyebrow shows from `lg` up only; below `lg` the header's sheet
 * button says the same thing. `eyebrow` is omitted for a step that is not a numbered section
 * (Review). The h1 takes focus after a move, so it is focusable but not tabbable.
 */
export function SectionCard({ eyebrow, title, headingRef, intro, children }: {
  eyebrow?: string;
  title: ReactNode;
  headingRef?: Ref<HTMLHeadingElement>;
  intro?: ReactNode;
  children?: ReactNode;
}) {
  return (
    <div className="min-w-0 rounded-token border border-line bg-surface p-5 shadow-panel sm:p-8">
      {eyebrow && (
        <p className="m-0 mb-2 hidden text-[10px] font-semibold uppercase tracking-[0.12em] text-slate lg:block">{eyebrow}</p>
      )}
      <h1 ref={headingRef} tabIndex={-1} className="m-0 font-serif text-[28px] font-normal tracking-[-0.01em] text-navy outline-none">
        {title}
      </h1>
      {intro && <div className="mt-3 text-[13px] leading-relaxed text-mid">{intro}</div>}
      {children}
    </div>
  );
}
